var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm.isBareMode ? [_c('CustomerWidget')] : [_c('keep-alive', {
    attrs: {
      "include": "product"
    }
  }, [_c('router-view')], 1), _c('SideFloatBar', {
    ref: "floatBar",
    attrs: {
      "cartCount": _vm.cartCount,
      "customBadges": _vm.customBadges
    }
  }), _c('CustomerService')]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }